import { useEffect, useState } from "react";
import { useAuth } from "../Context/AuthContext/AuthContext";
import { JobApplication } from "../Entities/job-application.entity";
import JobApplicationService from "../Services/job.application.service";

export const useJobApplications = () => {
  const { isUserLoggedIn, user } = useAuth();
  const [jobApplications, setJobApplications] = useState<JobApplication[]>([]);
  const jobApplicationService = new JobApplicationService();

  const init = async (userId: string) => {
    try {
      const applications =
        await jobApplicationService.findAllJobApplicationByUserId(userId);
      setJobApplications(applications);
    } catch (error: any) {
      console.error("Error fetching job applications:", error);
      setJobApplications([]);
    }
  };

  useEffect(() => {
    if (isUserLoggedIn && user) {
      init(user._id);
    } else {
      setJobApplications([]);
    }
  }, [isUserLoggedIn, user]);

  return {
    jobApplications,
  };
};
